import _ from "lodash";
import {createSelector} from "@reduxjs/toolkit";

export const selectOrder = (selector, orderProperty = "identifier", direction = "asc") => createSelector(
  selector, unordered => _.orderBy(unordered, orderProperty, direction)
);
